// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PArrowRightOutlinedSvg from "@fishx/icons-svg/es/asn/PArrowRightOutlined";
import FishxIcon from '../components/FishxIcon';

var PArrowRightOutlined = function PArrowRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PArrowRightOutlinedSvg
  }));
};

PArrowRightOutlined.displayName = 'PArrowRightOutlined';
export default React.forwardRef(PArrowRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PArrowRightOutlined.js
// module id = 3218
// module chunks = 0